import { CONSTANTS } from '..'

export const filterConditions = {
  [CONSTANTS.FIELDTYPES.DATETIME]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Is greater than', value: 'greaterThan' },
    { label: 'Is greater than equals', value: 'greaterThanEquals' },
    { label: 'Is less than', value: 'lessThan' },
    { label: 'Is less than equals', value: 'lessThanEquals' },
  ],
  [CONSTANTS.FIELDTYPES.TEXT]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Starts with', value: 'startsWith' },
    { label: 'Ends with', value: 'endsWith' },
    { label: 'Contains', value: 'contains' },
    // { label: 'Has value', value: 'in' },
  ],
  [CONSTANTS.FIELDTYPES.SELECT]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Has value', value: 'in' },
    { label: 'Null', value: 'null' },
  ],
  [CONSTANTS.FIELDTYPES.BOOLEAN]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Null', value: 'null' },
  ],
  [CONSTANTS.FIELDTYPES.NUMBER]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Is greater than', value: 'greaterThan' },
    { label: 'Is greater than equals', value: 'greaterThanEquals' },
    { label: 'Is less than', value: 'lessThan' },
    { label: 'Is less than equals', value: 'lessThanEquals' },
  ],
}

export const defaultFilterConditionValue = 'equals'

export const assetDefaultFields = [
  {
    id: 'image',
    fieldName: 'image',
    label: 'Image',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 0,
    class: 'list_image',
  },
  {
    id: 'blitzId',
    fieldName: 'blitzId',
    label: 'Blitz Id',
    fieldType: 'NUMBER',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 1,
    class: 'list_asset_id',
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.NUMBER],
  },
  {
    id: 'avsContentStatus',
    fieldName: 'avsContentStatus',
    label: 'AVS Status',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 2,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'contentId',
    fieldName: 'contentId',
    label: 'AVS Content Id',
    fieldType: 'NUMBER',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 3,
    class: '',
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.NUMBER],
  },
  {
    id: 'state',
    fieldName: 'state',
    label: 'Asset State',
    sort: true,
    filter: false,
    viewInListing: true,
    position: 5,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'assetType',
    fieldName: 'assetType',
    label: 'Asset Type',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 6,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'assetCategory',
    fieldName: 'assetCategory',
    label: 'Asset Category',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 7,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'contentCategory',
    fieldName: 'contentCategory',
    label: 'Content Category',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 8,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },

  {
    id: 'createdAt',
    fieldName: 'createdAt',
    label: 'Creation Date',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 14,
    fieldType: CONSTANTS.FIELDTYPES.DATETIME,
    filterValueType: CONSTANTS.FIELDTYPES.DATETIME,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.DATETIME],
  },
]

export const assetStatusDefaultFields = [
  {
    id: 'image',
    fieldName: 'image',
    label: 'Image',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 0,
    class: 'list_image',
  },
  {
    id: 'blitzId',
    fieldName: 'blitzId',
    label: 'Blitz Id',
    fieldType: 'NUMBER',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 1,
    class: 'list_asset_id',
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.NUMBER],
  },
  {
    id: 'contentId',
    fieldName: 'contentId',
    label: 'AVS Content Id',
    fieldType: 'NUMBER',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 3,
    class: '',
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.NUMBER],
  },
  {
    id: 'state',
    fieldName: 'state',
    label: 'Asset State',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 5,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'assetType',
    fieldName: 'assetType',
    label: 'Asset Type',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 6,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'assetCategory',
    fieldName: 'assetCategory',
    label: 'Asset Categroy',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 7,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'contentCategory',
    fieldName: 'contentCategory',
    label: 'Content Category',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 8,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },
  {
    id: 'avsContentStatus',
    fieldName: 'avsContentStatus',
    label: 'AVS Status',
    sort: false,
    filter: false,
    viewInListing: true,
    position: 2,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.TEXT],
  },

  {
    id: 'createdAt',
    fieldName: 'createdAt',
    label: 'Creation Date',
    sort: true,
    filter: true,
    viewInListing: true,
    position: 14,
    fieldType: CONSTANTS.FIELDTYPES.DATETIME,
    filterValueType: CONSTANTS.FIELDTYPES.DATETIME,
    filterValueCondition: filterConditions[CONSTANTS.FIELDTYPES.DATETIME],
  },
]
